import React from 'react';
import { withLocalize } from 'react-localize-redux';
import styled from 'styled-components';
import { Image, Grid } from 'semantic-ui-react';

export const DemoSection = ({ translate }) => (
  <Wrapper>
    <Grid
      container columns='2' centered
      stackable
    >
      <Grid.Row textAlign='left' centered>
        <Grid.Column
          className='left' verticalAlign='middle' computer='8'
          tablet='12' mobile='10'
        >
          <Title>
            {translate('text.demoSectionMessage')}
          </Title>
          <Paragraph>
            {translate('eventInfo.description')}
          </Paragraph>
          <BtnContainer>
            <LearnMoreButton
              href='https://www.hackhub.com/event'
              target='_blank' rel='noreferrer'
            >{translate('button.learnMore')}
            </LearnMoreButton>
            <DemoRequestButton href='https://www.hackhub.com/event/demo' target='_blank' rel='noreferrer'>
              {translate('button.getDemo')}
            </DemoRequestButton>
          </BtnContainer>

        </Grid.Column>
        <Grid.Column
          computer='8' tablet='12' mobile='10'
          className='right'
        >
          <Image src='/img/general/event-dashboard-2.png' alt='event dashboard' size='massive' />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Wrapper>
);

export const Demo = withLocalize(DemoSection);

const Wrapper = styled.div`
  padding: 3rem 0;
  background: #E6F5FF;
  height: auto;

  @media only screen and (max-width: 991px) {
    padding: 5rem 0;
  }
`;

const Paragraph = styled.p`
  margin-left: 2rem;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #667085;
  padding: 1rem 0;

  @media only screen and (max-width: 375px) { 
      text-align:center;
      margin-left: 0;
    }
`;

const Title = styled.h1`
  && {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 48px;
    line-height:60px;
    color: #101828;
    margin-left: 2rem;
    @media only screen and (max-width: 375px) { 
      font-size: 36px;
      line-height: 40px;
      text-align:center;
      margin-left: 0;
    }
  }
`;

const LearnMoreButton = styled.a`
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #344054;
  padding: 0.6em 1.2em;
  margin: 2rem 1rem;
  width: fit-content;

  @media only screen and (max-width: 375px) { 
    margin: 1rem;
    width: 80%;
    text-align:center;
  }
`;

const DemoRequestButton = styled(LearnMoreButton)`
  && {
    background: #0094FB;
    color: #FFFFFF;

    :hover{
    background-color: #0094fb;
    opacity: 0.8;
    border: 1px solid transparent;
    }

    @media only screen and (max-width: 375px) { 
    width: 80%;
    text-align:center;
  }
  }
`;

const BtnContainer = styled.div`
  display: flex;

  @media only screen and (max-width: 375px) { 
    flex-direction: column;
    width: 100%;
    justify-content:center;
    align-items:center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/events/components/demo.js